/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Mistake_6Inputs */

const en_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not getting the offer in writing`)
};

const de_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Angebot nicht schriftlich einholen`)
};

const fr_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne pas obtenir l'offre par écrit`)
};

const es_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No obtener la oferta por escrito`)
};

const it_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ottenere l'offerta per iscritto`)
};

const nl_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het aanbod niet schriftelijk krijgen`)
};

const pl_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak uzyskania oferty na piśmie`)
};

const fi_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjouksen kirjallisen vahvistuksen laiminlyönti`)
};

const da_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke at få tilbuddet skriftligt`)
};

const sv_salary_negotiate_mistake_6 = /** @type {(inputs: Salary_Negotiate_Mistake_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att inte få erbjudandet skriftligt`)
};

/**
* | output |
* | --- |
* | "Not getting the offer in writing" |
*
* @param {Salary_Negotiate_Mistake_6Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_mistake_6 = /** @type {((inputs?: Salary_Negotiate_Mistake_6Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Mistake_6Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_mistake_6(inputs)
	if (locale === "fr") return fr_salary_negotiate_mistake_6(inputs)
	if (locale === "es") return es_salary_negotiate_mistake_6(inputs)
	if (locale === "it") return it_salary_negotiate_mistake_6(inputs)
	if (locale === "nl") return nl_salary_negotiate_mistake_6(inputs)
	if (locale === "pl") return pl_salary_negotiate_mistake_6(inputs)
	if (locale === "fi") return fi_salary_negotiate_mistake_6(inputs)
	if (locale === "da") return da_salary_negotiate_mistake_6(inputs)
	if (locale === "sv") return sv_salary_negotiate_mistake_6(inputs)
	return en_salary_negotiate_mistake_6(inputs)
});